<template>
<div class="chapter">
<div class="inner_page">
<h2 class="recphd" id="c03_sec3"><a id="page33"></a><span href="#/OEBPS/toc#c03_sec3" title="Link target outside of Sample">Daikon Radish Salad <em>with</em> Crispy Shallots, Walnuts, <em>and</em> Asian Pear Dressing</span></h2>
<p class="serv"><em>4 to 8 servings</em></p>
<p class="serv1"><strong>PREP TIME</strong></p>
<p class="serv1"><em>30 minutes</em></p>
<p class="serv1"><strong>COOKING TIME</strong></p>
<p class="serv1"><em>1 hour 30 minutes</em></p>
<p class="serv1"><strong>TOTAL TIME</strong></p>
<p class="serv1"><em>2 hours</em></p>
<p class="nont">1 pound daikon radish, peeled and thinly sliced</p>
<p class="non">1 pound watermelon radishes, peeled and thinly sliced</p>
<p class="non">3 large carrots, shaved into thin strips with a vegetable peeler</p>
<p class="non">2 cups arugula</p>
<p class="non">¾ cup pomegranate seeds (about ½ pomegranate)</p>
<p class="non">1 recipe Poached Pears in an <span href="#/OEBPS/c12_sec22#page211" title="Link target outside of Sample">African Nectar Tea Broth</span></p>
<p class="non">¼ cup white wine vinegar</p>
<p class="non">1 shallot, minced</p>
<p class="non">1 bird’s-eye chile, minced</p>
<p class="non">2 teaspoons Dijon mustard</p>
<p class="non">1 cup olive oil</p>
<p class="non">kosher salt and freshly ground black pepper</p>
<p class="non">¼ cup Crispy Shallots (recipe below)</p>
<p class="nonb">1 cup <a href="#/OEBPS/c03_sec3#page34">Spiced Walnuts</a>; or good store-bought spiced walnuts, crushed)</p>
<p class="extract">I like radishes because they give a mild, peppery heat and they’re consistent throughout the year. Daikon radishes are closely identified with Japan, even though they’re originally from Southeast Asia, where they continue to find new uses for them. For this dish, getting the crispy shallots just right is the hardest part: You want to let them get golden brown and really, really crispy — so they can stand up to the dressing like a good onion ring can stand up to a dipping sauce. Don’t neglect the shallots.</p>
<p class="indent">The Asian pear dressing is one of my favorites. The African nectar tea is very fruit forward and herby, a surprising but perfect base for the dressing. And of course, you can whip up a batch of the African nectar tea as a pairing drink for the salad.</p>
<p class="indent">In a large bowl, gently toss together the radishes, carrots, arugula, and pomegranate seeds.</p>
<p class="indent">Combine 1 cup of the liquid from the poached pears with the vinegar, minced shallot, chile, and mustard in a blender. Blend until smooth. Slowly add the oil, continuing to blend until the dressing is thick and creamy. Season to taste with salt and pepper.</p>
<p class="indent">Lightly coat the salad with about ¼ cup of the blended dressing and gently toss again.</p>
<p class="indent">Cut the poached pears in half lengthwise and place each half flat side down on a cutting board; slice through each pear from the bottom every ¼ inch until about three quarters of the way up, so that the pear is still attached at the very top.</p>
<p class="indent">Fan out the sliced pears on serving plates and arrange the dressed salad next to them. Top with the shallots and walnuts.</p>
<h2 class="recphd1" id="c03_secc4"><a id="page33a"></a>CRISPY SHALLOTS</h2>
<p class="serv"><em>Makes 1/2 cup</em></p>
<p class="serv1"><strong>PREP TIME</strong></p>
<p class="serv1"><em>5 minutes</em></p>
<p class="serv1"><strong>COOKING TIME</strong></p>
<p class="serv1"><em>8 minutes</em></p>
<p class="serv1"><strong>TOTAL TIME</strong></p>
<p class="serv1"><em>13 minutes</em></p>
<p class="nont1"><em>1 cup vegetable oil</em></p>
<p class="non1">3 large shallots, peeled and thinly sliced</p>
<p class="nonb1">kosher salt</p>
<p class="indent">In a 2-quart saucepan, heat the oil to 320°F.</p>
<p class="indent">Carefully add the shallots and fry until light brown, about 8 minutes. Remove the shallots from the oil with a slotted spoon and place on paper towels to remove excess oil and cool. Season the shallots with salt as they start to cool.</p>
<p class="extract0"><strong>CHEF JJ’S KITCHEN TIPS</strong></p>
<div class="block">
<p class="indent">When frying something like the crispy shallots, always make sure to season the item as soon as it comes out of the oil to drain. This ensures that the seasoning will be absorbed properly.</p>
</div>
<h2 class="recphd1" id="c03_secc5"><a id="page34"></a>SPICED WALNUTS</h2>
<p class="serv"><em>Makes 2 cups</em></p>
<p class="serv1"><strong>PREP TIME</strong></p>
<p class="serv1"><em>5 minutes</em></p>
<p class="serv1"><strong>COOKING TIME</strong></p>
<p class="serv1"><em>35 minutes</em></p>
<p class="serv1"><strong>TOTAL TIME</strong></p>
<p class="serv1"><em>40 minutes</em></p>
<p class="nont1">8 ounces walnuts</p>
<p class="non1">¼ cup sugar</p>
<p class="non1">¼ teaspoon ground cayenne</p>
<p class="non1">2 teaspoons kosher salt</p>
<p class="nonb1">1 cup vegetable oil</p>
<p class="indent">In a 4-quart pot, cover the walnuts with just enough water to submerge them completely and bring to a boil; boil for 10 minutes.</p>
<p class="indent">Drain the walnuts, put them in a bowl, and pat dry with a paper towel. Add the sugar, cayenne, and salt and toss with a large spoon to coat the nuts with the mixture.</p>
<p class="indent">Remove the nuts from the spiced sugar and sift off the excess mixture.</p>
<p class="indent">Heat the oil in a 2-quart saucepan and fry the nuts until golden brown and fragrant, about 5 minutes. Remove the walnuts from the oil with a slotted spoon and place on paper towels to drain.</p>
<p class="indent">Let cool for 20 minutes, then crush the walnuts in a food processor on the pulse setting or with a heavy pan.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c03_sec3.vue?5e111b74